var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"facebook-login-lg w-100",attrs:{"variant":"outline-secondary"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'facebook-square']}}),_c('span',[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }